import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from '@wz-services';
import {
  NpsQuestions,
  NpsReponse,
} from 'libs/modules/tunnelsante/services/api/api-service-base';
import { NpsApiService } from 'libs/modules/tunnelsante/services/api/nps-api.service';
import { LoadingService } from 'libs/modules/tunnelsante/services/loading.service';

@Component({
  selector: 'wz-prospect',
  templateUrl: './prospect.component.html',
  styleUrls: ['./prospect.component.scss'],
  standalone: false,
})
export class ProspectComponent implements OnInit, AfterContentInit {
  items: Array<any> = [
    { question: 'Délai de rappel trop long', id: 1 },
    {
      question: 'Expertise et qualité du conseil apporté par mon conseiller',
      id: 2,
    },
    { question: 'Qualité des contrats proposés', id: 3 },
    { question: 'Rapport qualité/prix des contrats proposés', id: 4 },
    { question: 'Adéquation des propositions aux besoins exprimés', id: 5 },
    {
      question: 'Expertise et qualité du conseil apporté par mon conseiller',
      id: 6,
    },
    { question: '???', id: 7 },
    { question: 'Autre', id: 8 },
  ];

  form: FormGroup | any;

  questionPoser!: string;

  itemsQuestion!: NpsQuestions[];
  leadid: number = 0;
  loading: boolean = false;

  isAutre: boolean = false;

  constructor(
    fb: FormBuilder,
    private serviceNps: NpsApiService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: LoadingService,
    private loggerService: LoggerService,
  ) {
    this.form = fb.group({
      selectedQuestion: new FormArray([]),
      message: new FormControl(''),
    });
  }

  onCheckboxChange(event: any) {
    const selectedQuestion = this.form.controls.selectedQuestion as FormArray;
    if (event.target.value === '16' || event.target.value === '8') {
      this.isAutre = !this.isAutre;
    }
    if (event.target.checked) {
      selectedQuestion.push(new FormControl(event.target.value));
    } else {
      const index = selectedQuestion.controls.findIndex(
        (x) => x.value === event.target.value,
      );
      selectedQuestion.removeAt(index);
    }
  }

  checkDisabling(questionID: any) {
    if (this.form.value.selectedQuestion.length < 3) {
      return false;
    }

    return !this.form.value.selectedQuestion.includes(questionID.toString());
  }

  ngOnInit() {
    this.leadid = 0;
    if (this.route.snapshot.queryParamMap.get('id')) {
      var a: any = this.route.snapshot.queryParamMap.get('id');
      var parametre = atob(a);
      var parametreSplit = parametre.split(' ');
      this.leadid = parseInt(parametreSplit[5]);
    } else {
      this.router.navigate(['/']);
    }
    this.serviceNps.getProspectQuestions().subscribe(
      (result) => {
        this.itemsQuestion = result;
      },
      (error) => {
        alert(error.message);
      },
    );
  }

  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }

  submit() {
    this.loggerService.log(this.form.value);
    var selectedQ = '';
    for (let i = 0; i < this.form.value.selectedQuestion.length; i++) {
      if (i != this.form.value.selectedQuestion.length - 1) {
        selectedQ += this.form.value.selectedQuestion[i] + ',';
      } else {
        selectedQ += this.form.value.selectedQuestion[i];
      }
    }
    var npsRep: NpsReponse = {
      ID: 0,
      questionsID: selectedQ,
      message: this.form.value.message,
      leadid: this.leadid,
      reponseDate: new Date(),
      type: 'prospect',
    };

    this.serviceNps.saveReponse(npsRep).subscribe(
      (result) => {
        this.router.navigate(['/remerciements']);
      },
      (error) => {
        this.router.navigate(['/oops']);
      },
    );
  }
}
